import { useEffect, useState } from "react";
import {
  extractWistiaId,
  fetchWistiaShareLinkId,
  isWistiaShareLink,
} from "@/lib/utils/wistia";

/**
 * Returns the Wistia media ID for a video URL. Share links (`/s/<id>`) don't
 * contain the media ID, so they are resolved via oEmbed after mount.
 */
export function useWistiaId(url: string | undefined): string | undefined {
  const [resolved, setResolved] = useState<{ url: string; id?: string }>();

  useEffect(() => {
    if (!isWistiaShareLink(url)) return;

    let cancelled = false;
    fetchWistiaShareLinkId(url).then((id) => {
      if (!cancelled) setResolved({ url, id });
    });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (isWistiaShareLink(url)) {
    return resolved?.url === url ? resolved.id : undefined;
  }
  return extractWistiaId(url);
}
